import React, { useState, useEffect } from 'react'
import classes from './CompanyProfile.module.css'
import ProfileCard from './ProfileCard'
import TruckTypes from './TruckTypes'
import Teams from './Teams'
import Financials from './Financials';
import TNC from './TNC'
import Map from './Map'
// import {response} from './res'
import axios from '../../Axios/ActivityAxios'
import { Urls } from '../../Urls'
const CompanyProfile = props => {
    const [profile, setprofile] = useState({})
    // var id="COM9999999"

    useEffect(() => {

        if (props.match && props.match.params && props.match.params.id) {
            getCompanyData(props.match.params.id)
            getNetworkData()
        }

        // setProfile({
        //     'company_name': response.company_name,
        //     'hq_address': response.hq_address,
        //     'company_type': response.company_type,
        //     'expressed_interest': response.expressed_interest,
        //     'website': response.website,
        //     'established': response.established,
        //     'industries': response.industries,
        //     'product_categories': response.product_categories
        // })
    }, [props.match && props.match.params && props.match.params.id])
    const getCompanyData = (companyid) => {
        axios.get(`${Urls.companyProfile}?company_id=${companyid}`)
            .then(res => {
                if (res.data.company_profile)
                    setprofile(res.data.company_profile['0'])
            })
    }

    const getNetworkData = () => {
        axios.get(`${Urls.Network_data.Get}`)
            .then((res) => {
                if (res && res.data && res.data.locations) {
                    setprofile(prev => ({ ...prev, locations: res.data.locations ?? [] }));
                }
                if (res && res.data && res.data.network) {
                    setprofile(prev => ({ ...prev, network: res.data.network ?? [] }));
                }
            }).catch((err) => {
                console.error(err, "err")
            })
    }

    return (
        <div className={classes['Container']}>
            <div className={classes['Body']}>
                <div className={classes['LeftCol']}>
                    <ProfileCard profile={profile.company_id ? profile : undefined} />
                    <TruckTypes TruckTypesList={profile.truck_asset_details} />
                    <Teams teams={profile.contact_information} />
                    <Financials Financials={profile.financials} />
                </div>
                <div className={classes['RightCol']}>
                    <TNC TNC={profile.terms_and_conditions} />
                    <Map data={profile.locations} network={profile.network} />
                </div>
            </div>

        </div>
    )
}


export default CompanyProfile
